import type { ReportRecordValue } from 'client/js/main/types/analytics';
import { addDays, format, parse } from 'date-fns';

export const weekFormatter = (value: ReportRecordValue) => {
  if (typeof value !== 'string') {
    return value;
  }

  const outputFormat = 'yyyy/MM/dd';
  const sunday = parse(value, 'yyyy-MM-dd', new Date());
  const nextSaturday = addDays(sunday, 6);
  const formattedSunday = format(sunday, outputFormat);
  const formattedNextSaturday = format(nextSaturday, outputFormat);
  return `${formattedSunday} - ${formattedNextSaturday}`;
};
